import React from "react";

/** تصویر برداری ساده از بندر (جایگزین عکس). اگر عکس واقعی خواستید، در CSS/JSX عوض کنید. */
export default function PortScene({ className = "", style }) {
  return (
    <svg className={className} style={style} viewBox="0 0 600 340" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <linearGradient id="ps-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1c4f86" /><stop offset=".55" stopColor="#5b86b5" /><stop offset=".85" stopColor="#f0b98a" /><stop offset="1" stopColor="#f6d3a8" />
        </linearGradient>
        <linearGradient id="ps-sea" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#3f6c9b" /><stop offset="1" stopColor="#0b2e50" />
        </linearGradient>
      </defs>
      <rect width="600" height="340" fill="url(#ps-sky)" />
      <circle cx="430" cy="196" r="34" fill="#fff4dc" opacity=".55" />
      <rect y="206" width="600" height="134" fill="url(#ps-sea)" />
      <g opacity=".25" stroke="#fff" strokeWidth="1.5">
        <path d="M20 240h90M150 262h120M320 246h100M470 270h110M60 296h140M260 304h130" />
      </g>
      {/* کشتی */}
      <g fill="#102b46">
        <path d="M60 214h250l-26 34H92z" />
        <rect x="96" y="190" width="150" height="24" />
        <rect x="120" y="170" width="46" height="20" /><rect x="132" y="154" width="20" height="16" />
      </g>
      <g fill="#E63946"><rect x="96" y="208" width="190" height="6" /></g>
      <g fill="#f3f4f6" opacity=".85"><rect x="106" y="196" width="10" height="7" /><rect x="124" y="196" width="10" height="7" /><rect x="142" y="196" width="10" height="7" /><rect x="124" y="176" width="36" height="6" /></g>
      {/* اسکله و جرثقیل */}
      <rect x="330" y="236" width="270" height="104" fill="#0a1f36" />
      <g stroke="#0D3B66" strokeWidth="5" fill="none" strokeLinecap="round">
        <path d="M382 236V100M430 236V100M382 140h48M382 180h48M382 100l48 40M430 100l-48 40" />
        <path d="M340 100h190" strokeWidth="8" />
        <path d="M530 100l-8 -18M340 100l8 -18" />
      </g>
      <g stroke="#E63946" strokeWidth="3"><path d="M500 100v52" /></g>
      <rect x="490" y="150" width="20" height="14" fill="#E63946" />
      <g stroke="#0D3B66" strokeWidth="4" fill="none" strokeLinecap="round">
        <path d="M530 236V130M556 236V130M530 170h26M530 130l26 40M556 130l-26 40" />
      </g>
      <g fill="#14375c"><rect x="340" y="214" width="34" height="22" /><rect x="376" y="214" width="34" height="22" /><rect x="344" y="196" width="34" height="18" /></g>
    </svg>
  );
}
